import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_31 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_32 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_34 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_35 = { class: "dropdown-menu" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "" }
const _hoisted_39 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  colspan: "10",
  class: "text-center text-muted py-20"
}
const _hoisted_42 = {
  key: 1,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_43 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_44 = { class: "fw-bold" }
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_47 = { class: "fw-bold" }
const _hoisted_48 = { class: "fw-bold" }
const _hoisted_49 = { class: "mt-15 mt-md-0" }
const _hoisted_50 = { class: "pagination mb-0" }
const _hoisted_51 = {
  key: 0,
  class: "page-item"
}
const _hoisted_52 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 1,
  class: "page-item"
}

import { ref, computed, onMounted, inject, watch } from "vue";
import axios from 'axios';
import router from '../../router/index';
import { useI18n } from "vue-i18n";
import { current_permissions } from '../../utils/permission';
import { checkSessionValidate } from '../../utils/function';

const pageSize = 15;


export default /*@__PURE__*/_defineComponent({
  __name: 'tokenListPageContent',
  setup(__props) {

const backApi = inject('back');
const { t } = useI18n();

const token = ref<string | null>(localStorage.getItem('login_token'));
const pageLoad = ref(false);
const tokens = ref<any[]>([]);
const revokeError = ref('');
const loading = ref(false);

const searchQuery = ref('');
const page = ref(1);
function formatDateFr(value: Date | null): string {
  if (!value) return '-';
  const year = value.getFullYear();
  let month = value.getMonth() + 1;
  const monthStr = month < 10 ? '0' + month : String(month);
  let day = value.getDate();
  const dayStr = day < 10 ? '0' + day : String(day);
  const hours = String(value.getHours()).padStart(2, '0');
  const minutes = String(value.getMinutes()).padStart(2, '0');
  return dayStr + '/' + monthStr + '/' + year + ' ' + hours + ':' + minutes;
}

const filteredTokens = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return tokens.value;

  return tokens.value.filter((item) => {
    const haystack = [
      item.code || '',
      item.user?.code || '',
      item.user?.email || '',
      item.user?.type || '',
      item.deviceId || '',
      item.ipAddress || '',
      item.createdAt ? formatDateFr(new Date(item.createdAt)) : '',
      item.expiresAt ? formatDateFr(new Date(item.expiresAt)) : '',
      item.revokedAt ? 'revoque' : 'actif',
    ]
      .join(' ')
      .toLowerCase();

    return haystack.includes(q);
  });
});

const filteredTotal = computed(() => filteredTokens.value.length);

const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize)));

const paginatedTokens = computed(() => {
  const start = (page.value - 1) * pageSize;
  return filteredTokens.value.slice(start, start + pageSize);
});

const showingFrom = computed(() => {
  if (filteredTotal.value === 0) return 0;
  return (page.value - 1) * pageSize + 1;
});

const showingTo = computed(() => {
  return Math.min(page.value * pageSize, filteredTotal.value);
});

function goToPage(target: number) {
  if (target < 1 || target > numPages.value) return;
  page.value = target;
}

watch(numPages, (max) => {
  if (page.value > max) page.value = max;
});


// Récupère une page de tokens depuis l'API (forme { data, pagination })
const fetchTokensPage = (targetPage: number) => {
  const url = `${backApi}/secure/token/sessions?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token.value}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
};

const getTokens = async () => {
  try {
    const first = await fetchTokensPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchTokensPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    tokens.value = collected;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      }
      console.error('Error fetching tokens:', error.response.data);
    }
  }
};

const refreshTokens = () => {
  getTokens();
};

const confirmRevoke = (tok: any) => {
  revokeError.value = '';
  const ok = window.confirm(
    `${t('tokens.revokeMessage')}\n${t('tokens.user')}: ${tok.user?.email || '-'}`
  );
  if (ok) {
    revokeToken(tok);
  }
};

const revokeToken = (tok: any) => {
  loading.value = true;
  revokeError.value = '';

  axios.post(`${backApi}/secure/token/revoke`, {
    user: tok.user?.code
  }, {
    headers: {
      Authorization: `Bearer ${token.value}`,
      'Content-Type': 'application/json'
    }
  })
  .then(() => {
    getTokens();
  })
  .catch((error) => {
    if (error.response) {
      revokeError.value = error.response.data?.message || t('tokens.revokeError');
      if (error.response.status === 401) {
        router.push('/');
      }
    } else {
      revokeError.value = t('tokens.revokeError');
    }
  })
  .finally(() => {
    loading.value = false;
  });
};

onMounted(async () => {
  checkSessionValidate(1);
  await getTokens();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: _ctx.$t('tokens.search'),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (page.value = 1))
              }, null, 40, _hoisted_5), [
                [_vModelText, searchQuery.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                style: {"background-color":"#EB9355"},
                onClick: refreshTokens
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('tokens.refresh')) + " ", 1),
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "flaticon-refresh position-relative ms-5 fs-12" }, null, -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (revokeError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(revokeError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('tokens.code')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('tokens.user')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('tokens.email')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('tokens.type')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('tokens.deviceId')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('tokens.ipAddress')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('tokens.createdAt')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('tokens.expiresAt')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('tokens.status')), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedTokens.value, (tok) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: tok.code
                    }, [
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("span", {
                          class: "text-truncate d-inline-block",
                          style: {"max-width":"120px"},
                          title: tok.code
                        }, _toDisplayString(tok.code.substring(0, 8)) + "... ", 9, _hoisted_21)
                      ]),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(tok.user?.code || '-'), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(tok.user?.email || '-'), 1),
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", tok.user?.type === 'API' ? 'text-outline-primary' : 'text-outline-secondary'])
                        }, _toDisplayString(tok.user?.type || '-'), 3)
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("span", {
                          class: "text-truncate d-inline-block",
                          style: {"max-width":"100px"},
                          title: tok.deviceId
                        }, _toDisplayString(tok.deviceId ? tok.deviceId.substring(0, 10) + '...' : '-'), 9, _hoisted_26)
                      ]),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(tok.ipAddress || '-'), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(tok.createdAt ? formatDateFr(new Date(tok.createdAt)) : '-'), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(tok.expiresAt ? formatDateFr(new Date(tok.expiresAt)) : '-'), 1),
                      _createElementVNode("td", _hoisted_30, [
                        (!tok.revokedAt)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('tokens.active')), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('tokens.revoked')), 1))
                      ]),
                      _createElementVNode("td", _hoisted_33, [
                        (!tok.revokedAt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _cache[8] || (_cache[8] = _createElementVNode("button", {
                                class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                type: "button",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false"
                              }, [
                                _createElementVNode("i", { class: "flaticon-dots" })
                              ], -1)),
                              _createElementVNode("ul", _hoisted_35, [
                                (_unref(current_permissions)('revoke_token'))
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item d-flex align-items-center",
                                        style: {"color":"red"},
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (confirmRevoke(tok))
                                      }, [
                                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('tokens.revoke')), 1)
                                      ], 8, _hoisted_37)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_39, "-"))
                      ])
                    ]))
                  }), 128)),
                  (filteredTotal.value === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                        _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.$t('tokens.noResults') || '-'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (filteredTotal.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  (filteredTotal.value>pageSize)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                        _createTextVNode(_toDisplayString(_ctx.$t('tokens.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(showingFrom.value) + "-" + _toDisplayString(showingTo.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('tokens.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('tokens.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (filteredTotal.value<=pageSize)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                        _createTextVNode(_toDisplayString(_ctx.$t('tokens.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_47, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('tokens.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_48, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('tokens.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_49, [
                    _createElementVNode("ul", _hoisted_50, [
                      ((page.value-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage(page.value-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==page.value)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_52, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (goToPage(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_53))
                        ]))
                      }), 128)),
                      ((page.value+1)<=numPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPage(page.value+1))),
                              "aria-label": "Next"
                            }, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})